// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* CSS Variables for Theme Support */
:root {
  /* Light theme colors (ChatGPT style) */
  --bg-primary: #ffffff;
  --bg-secondary: #f7f7f8;
  --bg-tertiary: #ececec;
  --bg-user-message: #2f2f2f;
  --text-primary: #1f1f1f;
  --text-secondary: #6b6b6b;
  --text-tertiary: #8e8e8e;
  --text-user-message: #ffffff;
  --border-color: #e5e5e5;
  --border-light: #f0f0f0;
  --hover-color: #f5f5f5;
  --input-bg: #ffffff;
  --shadow-light: 0 1px 3px rgba(0, 0, 0, 0.08);
  --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.12);
  --shadow-heavy: 0 8px 24px rgba(0, 0, 0, 0.15);
  --accent-color: #10a37f;
  --accent-hover: #0d8f6f;
  --accent-light: rgba(16, 163, 127, 0.1);
  --primary-color: #10a37f;
  --success-color: #059669;
  --error-color: #dc2626;
  --warning-color: #f59e0b;
  --transition-fast: 0.15s ease;
  --transition-normal: 0.25s ease;
  --transition-slow: 0.4s ease;
}

[data-theme="dark"] {
  /* Dark Theme - Modern & Sleek */
  --bg-primary: #212121;
  --bg-secondary: #171717;
  --bg-tertiary: #2a2a2a;
  --bg-user-message: #2f2f2f;
  --text-primary: #ececec;
  --text-secondary: #a0a0a0;
  --text-tertiary: #707070;
  --text-user-message: #ffffff;
  --border-color: #3a3a3a;
  --border-light: #2f2f2f;
  --hover-color: #2f2f2f;
  --input-bg: #2f2f2f;
  --shadow-light: 0 1px 3px rgba(0, 0, 0, 0.4);
  --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.5);
  --shadow-heavy: 0 8px 24px rgba(0, 0, 0, 0.6);
  --accent-light: rgba(16, 163, 127, 0.15);
  --primary-color: #10a37f;
  --success-color: #10b981;
  --error-color: #ef4444;
  --warning-color: #fbbf24;
}

body {
  font-family: 'Söhne', 'Segoe UI', 'Roboto', 'Helvetica Neue', -apple-system, sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  font-size: 15px;
  height: 100vh;
  margin: 0;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app {
  display: flex;
  height: 100vh;
  background-color: var(--bg-primary);
  width: 100vw;
}

/* Sidebar Styles - Sleek & Modern */
.sidebar {
  width: 280px;
  min-width: 280px;
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  border-right: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
}

/* Hide scrollbar for Chrome/Safari */
.sidebar::-webkit-scrollbar {
  display: none;
}

.sidebar-header {
  padding: 12px;
  border-bottom: none;
  position: sticky;
  top: 0;
  background: var(--bg-secondary);
  z-index: 10;
}

.new-chat-btn {
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: 1px dashed var(--border-color);
  border-radius: 10px;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.new-chat-btn:hover {
  background-color: var(--hover-color);
  border-style: solid;
  border-color: var(--accent-color);
  color: var(--accent-color);
}

.sidebar-content {
  flex: 1 1;
  padding: 8px 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Tools section in sidebar */
.tools-section {
  background: var(--bg-tertiary);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 4px;
}

.tools-section h3 {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-tertiary);
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.tool-option {
  margin-bottom: 2px;
}

.toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text-primary);
  padding: 8px 10px;
  border-radius: 8px;
  transition: all 0.15s ease;
  margin: 2px 0;
}

.toggle:hover {
  background: var(--hover-color);
  color: var(--accent-color);
}

.toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--accent-color);
  cursor: pointer;
}

/* Main Content Styles */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-primary);
  min-width: 0;
}

.top-bar {
  padding: 12px 20px;
  background-color: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  min-height: 60px;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sidebar-toggle {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 15px;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.sidebar-toggle:hover {
  background-color: var(--hover-color);
  color: var(--text-primary);
}

/* Model selector on the left */
.model-selector-left {
  display: flex;
  align-items: center;
}

.model-dropdown {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  min-width: 120px;
  box-shadow: var(--shadow-light);
}

.model-dropdown:hover {
  border-color: var(--text-secondary);
  box-shadow: var(--shadow-medium);
}

.model-dropdown:focus {
  outline: none;
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px rgba(16, 163, 127, 0.1);
}

.messages-container {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
}

.messages-container::-webkit-scrollbar {
  width: 8px;
}

.messages-container::-webkit-scrollbar-track {
  background: transparent;
}

.messages-container::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.messages-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

.welcome-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  max-width: 680px;
  margin: 0 auto;
  padding: 60px 40px;
  font-size: 16px;
}

.welcome-message h1 {
  font-size: 28px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

/* Message Styles */
.message {
  display: flex;
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid transparent;
}

.message.user,
.message.assistant {
  background-color: transparent;
}

.message-content {
  max-width: 768px;
  margin: 0 auto;
  width: 100%;
  padding: 0 16px;
  line-height: 1.6;
  font-size: 20px;
}

/* Assistant message - clean text styling */
.message.assistant .message-content {
  color: var(--text-primary);
  display: block;
  text-align: left;
}

/* User message - elegant bubble */
.message.user .message-content {
  display: flex;
  justify-content: flex-end;
}

.message.user .message-content .user-bubble {
  background-color: var(--bg-user-message);
  border-radius: 18px;
  padding: 12px 18px;
  color: var(--text-user-message);
  max-width: 75%;
  word-wrap: break-word;
  font-weight: 400;
  box-shadow: var(--shadow-light);
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 16px 0;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--text-secondary);
  animation: typing 1.4s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typing {

  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }

  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Input Container - Modern & Clean */
.input-container {
  padding: 16px 24px 40px;
  background: linear-gradient(180deg, transparent 0%, var(--bg-primary) 20%);
}

.input-wrapper {
  max-width: 720px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--input-bg);
  border: 1px solid var(--border-color);
  border-radius: 24px;
  box-shadow: var(--shadow-medium);
  gap: 8px;
  padding: 8px 16px 8px 16px;
  transition: all 0.25s ease;
}

.input-wrapper:focus-within {
  border-color: var(--accent-color);
  box-shadow: var(--shadow-heavy), 0 0 0 2px var(--accent-light);
}

.message-input {
  flex: 1 1;
  min-height: 24px;
  max-height: 200px;
  padding: 8px 12px;
  border: none;
  background-color: transparent;
  color: var(--text-primary);
  font-size: 15px;
  font-family: inherit;
  resize: none;
  outline: none;
  overflow: hidden;
  line-height: 1.5;
}

.message-input::placeholder {
  color: var(--text-secondary);
  font-weight: 400;
}

.send-button {
  background-color: var(--accent-color);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  font-weight: 500;
  flex-shrink: 0;
}

.send-button:hover:not(:disabled) {
  background-color: var(--accent-hover);
  transform: scale(1.05);
  box-shadow: var(--shadow-medium);
}

.send-button:disabled {
  background-color: var(--text-tertiary);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

/* Enhanced message content styling - ChatGPT consistent sizes */
.message-content h1,
.message-content h2,
.message-content h3,
.message-content h4,
.message-content h5,
.message-content h6 {
  margin: 16px 0 8px 0;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-primary);
  font-size: 20px;
  /* Same as regular text for consistency */
}

.message-content ul,
.message-content ol {
  margin: 12px 0;
  padding-left: 20px;
}

.message-content li {
  margin: 4px 0;
  line-height: 1.5;
  font-size: 20px;
}

.message-content p {
  margin: 12px 0;
  line-height: 1.5;
  font-size: 20px;
}

.message-content code {
  background-color: var(--bg-secondary);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 14px;
  border: 1px solid var(--border-color);
}

.message-content pre {
  background-color: var(--bg-secondary);
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 12px 0;
  border: 1px solid var(--border-color);
  font-size: 14px;
}

.message-content pre code {
  background-color: transparent;
  padding: 0;
  border: none;
  font-size: 14px;
}

.message-content blockquote {
  border-left: 3px solid var(--accent-color);
  padding-left: 12px;
  margin: 12px 0;
  color: var(--text-secondary);
  font-style: italic;
  font-size: 20px;
}

.message-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 12px 0;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  overflow: hidden;
  font-size: 20px;
}

.message-content th,
.message-content td {
  border: 1px solid var(--border-color);
  padding: 8px 12px;
  text-align: left;
  font-size: 20px;
}

.message-content th {
  background-color: var(--bg-secondary);
  font-weight: 600;
  color: var(--text-primary);
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    width: 240px;
  }

  .message {
    padding: 16px 0;
  }

  .message-content {
    padding: 0 20px;
  }

  .input-container {
    padding: 16px 20px 24px;
  }

  .welcome-message {
    padding: 32px 20px;
  }

  .welcome-message h1 {
    font-size: 18px;
  }
}

@media (max-width: 640px) {
  .app {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: auto;
    flex-direction: row;
    border-right: none;
    border-bottom: 1px solid var(--border-color);
  }

  .sidebar-header {
    flex: 1 1;
    border-bottom: none;
    border-right: 1px solid var(--border-color);
  }

  .sidebar-content {
    flex: 2 1;
    padding: 16px;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }

  .tools-section {
    border-bottom: none;
    border-right: 1px solid var(--border-color);
    padding-right: 16px;
    padding-bottom: 0;
  }

  .top-bar {
    padding: 12px 16px;
  }

  .top-bar-left {
    gap: 12px;
  }
}

/* Plus button for attachments */
.upload-btn {
  cursor: pointer;
  font-size: 20px;
  -webkit-user-select: none;
          user-select: none;
  color: var(--text-secondary);
  transition: color 0.2s ease;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  line-height: 1;
}

.upload-btn:hover {
  color: var(--accent-color);
}

/* Memory-related styles */
.memory-section {
  border-top: 1px solid var(--border-color);
  padding-top: 16px;
  margin-top: 16px;
}

.memory-section h3 {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.memory-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  padding: 4px 8px;
  transition: all 0.2s ease;
}

.memory-btn:hover {
  background-color: var(--hover-color);
  border-color: var(--text-secondary);
}

.memory-panel {
  background-color: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  padding: 12px 20px;
  font-size: 13px;
}

.memory-item {
  margin-bottom: 8px;
  padding: 6px;
  background-color: var(--hover-color);
  border-radius: 4px;
  border: 1px solid var(--border-color);
}

.memory-item-meta {
  font-size: 11px;
  color: var(--text-secondary);
  margin-top: 4px;
}

/* Tab Navigation Styles */
.tab-navigation {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: 20px;
}

.tab-button {
  padding: 8px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.tab-button:hover {
  background: var(--hover-color);
  border-color: var(--accent-color);
}

.tab-button.active {
  background: var(--accent-color);
  color: white;
  border-color: var(--accent-color);
}

/* Custom Prompt Editor Styles */
.prompt-toggle-btn:hover {
  background-color: var(--hover-color) !important;
  border-color: var(--accent-color) !important;
}

.prompt-editor-textarea {
  width: 100%;
  min-height: 80px;
  max-height: 120px;
  padding: 6px;
  font-size: 10px;
  background-color: var(--input-bg);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  color: var(--text-primary);
  resize: vertical;
  font-family: 'SF Mono', Monaco, 'Roboto Mono', monospace;
  line-height: 1.3;
  transition: border-color 0.2s ease;
}

.prompt-editor-textarea:focus {
  outline: none;
  border-color: var(--accent-color);
  box-shadow: 0 0 0 2px rgba(16, 163, 127, 0.1);
}

.prompt-editor-buttons {
  display: flex;
  gap: 6px;
  margin-top: 8px;
}

.prompt-editor-btn {
  flex: 1 1;
  padding: 4px 6px;
  border: none;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.prompt-editor-btn.update {
  background-color: #10b981;
  color: white;
}

.prompt-editor-btn.update:hover {
  background-color: #059669;
}

.prompt-editor-btn.reset {
  background-color: #ef4444;
  color: white;
}

.prompt-editor-btn.reset:hover {
  background-color: #dc2626;
}

.prompt-current-preview {
  font-size: 9px;
  color: var(--text-secondary);
  margin-top: 4px;
  padding: 3px 4px;
  background-color: var(--bg-secondary);
  border-radius: 2px;
  border: 1px solid var(--border-color);
  max-height: 40px;
  overflow: hidden;
}

/* Modern Citation Card Styles */
.citation-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 8px 0;
  transition: all var(--transition-normal);
  cursor: pointer;
}

.citation-card:hover {
  background: var(--hover-color);
  border-color: var(--accent-color);
  box-shadow: var(--shadow-medium);
  transform: translateY(-1px);
}

.citation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.citation-badge {
  background: var(--accent-light);
  color: var(--accent-color);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.citation-title {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.4;
}

.citation-snippet {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.5;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.citation-meta {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  font-size: 11px;
  color: var(--text-tertiary);
}

.citation-similarity {
  background: var(--bg-tertiary);
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

/* Sources Panel Modern Style */
.sources-panel {
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  padding: 16px;
  margin: 12px 0;
}

.sources-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-light);
}

.sources-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sources-toggle {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  transition: all var(--transition-fast);
}

.sources-toggle:hover {
  background: var(--hover-color);
  color: var(--accent-color);
}

/* Smooth fade-in animation for messages */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message {
  animation: fadeInUp 0.3s ease-out;
}

/* Agent tools indicator */
.agent-tools-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--accent-light);
  color: var(--accent-color);
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
}

.agent-tools-badge::before {
  content: '🔧';
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,uCAAuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,6CAA6C;EAC7C,+CAA+C;EAC/C,8CAA8C;EAC9C,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,8CAA8C;EAC9C,6CAA6C;EAC7C,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,uFAAuF;EACvF,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;EACjD,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,oCAAoC;AACtC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,QAAQ;EACR,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,8DAA8D;AAChE;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,gEAAgE;AAChE;;;;;;EAME,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,SAAO;IACP,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,wDAAwD;EACxD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* CSS Variables for Theme Support */\n:root {\n  /* Light theme colors (ChatGPT style) */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f7f7f8;\n  --bg-tertiary: #ececec;\n  --bg-user-message: #2f2f2f;\n  --text-primary: #1f1f1f;\n  --text-secondary: #6b6b6b;\n  --text-tertiary: #8e8e8e;\n  --text-user-message: #ffffff;\n  --border-color: #e5e5e5;\n  --border-light: #f0f0f0;\n  --hover-color: #f5f5f5;\n  --input-bg: #ffffff;\n  --shadow-light: 0 1px 3px rgba(0, 0, 0, 0.08);\n  --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.12);\n  --shadow-heavy: 0 8px 24px rgba(0, 0, 0, 0.15);\n  --accent-color: #10a37f;\n  --accent-hover: #0d8f6f;\n  --accent-light: rgba(16, 163, 127, 0.1);\n  --primary-color: #10a37f;\n  --success-color: #059669;\n  --error-color: #dc2626;\n  --warning-color: #f59e0b;\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.25s ease;\n  --transition-slow: 0.4s ease;\n}\n\n[data-theme=\"dark\"] {\n  /* Dark Theme - Modern & Sleek */\n  --bg-primary: #212121;\n  --bg-secondary: #171717;\n  --bg-tertiary: #2a2a2a;\n  --bg-user-message: #2f2f2f;\n  --text-primary: #ececec;\n  --text-secondary: #a0a0a0;\n  --text-tertiary: #707070;\n  --text-user-message: #ffffff;\n  --border-color: #3a3a3a;\n  --border-light: #2f2f2f;\n  --hover-color: #2f2f2f;\n  --input-bg: #2f2f2f;\n  --shadow-light: 0 1px 3px rgba(0, 0, 0, 0.4);\n  --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.5);\n  --shadow-heavy: 0 8px 24px rgba(0, 0, 0, 0.6);\n  --accent-light: rgba(16, 163, 127, 0.15);\n  --primary-color: #10a37f;\n  --success-color: #10b981;\n  --error-color: #ef4444;\n  --warning-color: #fbbf24;\n}\n\nbody {\n  font-family: 'Söhne', 'Segoe UI', 'Roboto', 'Helvetica Neue', -apple-system, sans-serif;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  font-size: 15px;\n  height: 100vh;\n  margin: 0;\n  overflow: hidden;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.app {\n  display: flex;\n  height: 100vh;\n  background-color: var(--bg-primary);\n  width: 100vw;\n}\n\n/* Sidebar Styles - Sleek & Modern */\n.sidebar {\n  width: 280px;\n  min-width: 280px;\n  background-color: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  border-right: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  padding: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* Hide scrollbar but keep functionality */\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE/Edge */\n}\n\n/* Hide scrollbar for Chrome/Safari */\n.sidebar::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar-header {\n  padding: 12px;\n  border-bottom: none;\n  position: sticky;\n  top: 0;\n  background: var(--bg-secondary);\n  z-index: 10;\n}\n\n.new-chat-btn {\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: 1px dashed var(--border-color);\n  border-radius: 10px;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.new-chat-btn:hover {\n  background-color: var(--hover-color);\n  border-style: solid;\n  border-color: var(--accent-color);\n  color: var(--accent-color);\n}\n\n.sidebar-content {\n  flex: 1;\n  padding: 8px 12px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Tools section in sidebar */\n.tools-section {\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  padding: 12px;\n  margin-bottom: 4px;\n}\n\n.tools-section h3 {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n.tool-option {\n  margin-bottom: 2px;\n}\n\n.toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--text-primary);\n  padding: 8px 10px;\n  border-radius: 8px;\n  transition: all 0.15s ease;\n  margin: 2px 0;\n}\n\n.toggle:hover {\n  background: var(--hover-color);\n  color: var(--accent-color);\n}\n\n.toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent-color);\n  cursor: pointer;\n}\n\n/* Main Content Styles */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-primary);\n  min-width: 0;\n}\n\n.top-bar {\n  padding: 12px 20px;\n  background-color: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  min-height: 60px;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.sidebar-toggle {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 15px;\n  padding: 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n}\n\n.sidebar-toggle:hover {\n  background-color: var(--hover-color);\n  color: var(--text-primary);\n}\n\n/* Model selector on the left */\n.model-selector-left {\n  display: flex;\n  align-items: center;\n}\n\n.model-dropdown {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  box-shadow: var(--shadow-light);\n}\n\n.model-dropdown:hover {\n  border-color: var(--text-secondary);\n  box-shadow: var(--shadow-medium);\n}\n\n.model-dropdown:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 3px rgba(16, 163, 127, 0.1);\n}\n\n.messages-container {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  scroll-behavior: smooth;\n}\n\n.messages-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.messages-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.messages-container::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n.messages-container::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n\n.welcome-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 60px 40px;\n  font-size: 16px;\n}\n\n.welcome-message h1 {\n  font-size: 28px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n  letter-spacing: -0.5px;\n}\n\n/* Message Styles */\n.message {\n  display: flex;\n  width: 100%;\n  padding: 20px 0;\n  border-bottom: 1px solid transparent;\n}\n\n.message.user,\n.message.assistant {\n  background-color: transparent;\n}\n\n.message-content {\n  max-width: 768px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 16px;\n  line-height: 1.6;\n  font-size: 20px;\n}\n\n/* Assistant message - clean text styling */\n.message.assistant .message-content {\n  color: var(--text-primary);\n  display: block;\n  text-align: left;\n}\n\n/* User message - elegant bubble */\n.message.user .message-content {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.message.user .message-content .user-bubble {\n  background-color: var(--bg-user-message);\n  border-radius: 18px;\n  padding: 12px 18px;\n  color: var(--text-user-message);\n  max-width: 75%;\n  word-wrap: break-word;\n  font-weight: 400;\n  box-shadow: var(--shadow-light);\n}\n\n/* Typing Indicator */\n.typing-indicator {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  padding: 16px 0;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--text-secondary);\n  animation: typing 1.4s infinite ease-in-out;\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes typing {\n\n  0%,\n  80%,\n  100% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n\n  40% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Input Container - Modern & Clean */\n.input-container {\n  padding: 16px 24px 40px;\n  background: linear-gradient(180deg, transparent 0%, var(--bg-primary) 20%);\n}\n\n.input-wrapper {\n  max-width: 720px;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--input-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 24px;\n  box-shadow: var(--shadow-medium);\n  gap: 8px;\n  padding: 8px 16px 8px 16px;\n  transition: all 0.25s ease;\n}\n\n.input-wrapper:focus-within {\n  border-color: var(--accent-color);\n  box-shadow: var(--shadow-heavy), 0 0 0 2px var(--accent-light);\n}\n\n.message-input {\n  flex: 1;\n  min-height: 24px;\n  max-height: 200px;\n  padding: 8px 12px;\n  border: none;\n  background-color: transparent;\n  color: var(--text-primary);\n  font-size: 15px;\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  overflow: hidden;\n  line-height: 1.5;\n}\n\n.message-input::placeholder {\n  color: var(--text-secondary);\n  font-weight: 400;\n}\n\n.send-button {\n  background-color: var(--accent-color);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: var(--accent-hover);\n  transform: scale(1.05);\n  box-shadow: var(--shadow-medium);\n}\n\n.send-button:disabled {\n  background-color: var(--text-tertiary);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n/* Enhanced message content styling - ChatGPT consistent sizes */\n.message-content h1,\n.message-content h2,\n.message-content h3,\n.message-content h4,\n.message-content h5,\n.message-content h6 {\n  margin: 16px 0 8px 0;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--text-primary);\n  font-size: 20px;\n  /* Same as regular text for consistency */\n}\n\n.message-content ul,\n.message-content ol {\n  margin: 12px 0;\n  padding-left: 20px;\n}\n\n.message-content li {\n  margin: 4px 0;\n  line-height: 1.5;\n  font-size: 20px;\n}\n\n.message-content p {\n  margin: 12px 0;\n  line-height: 1.5;\n  font-size: 20px;\n}\n\n.message-content code {\n  background-color: var(--bg-secondary);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n}\n\n.message-content pre {\n  background-color: var(--bg-secondary);\n  padding: 12px;\n  border-radius: 6px;\n  overflow-x: auto;\n  margin: 12px 0;\n  border: 1px solid var(--border-color);\n  font-size: 14px;\n}\n\n.message-content pre code {\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  font-size: 14px;\n}\n\n.message-content blockquote {\n  border-left: 3px solid var(--accent-color);\n  padding-left: 12px;\n  margin: 12px 0;\n  color: var(--text-secondary);\n  font-style: italic;\n  font-size: 20px;\n}\n\n.message-content table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 12px 0;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  overflow: hidden;\n  font-size: 20px;\n}\n\n.message-content th,\n.message-content td {\n  border: 1px solid var(--border-color);\n  padding: 8px 12px;\n  text-align: left;\n  font-size: 20px;\n}\n\n.message-content th {\n  background-color: var(--bg-secondary);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 240px;\n  }\n\n  .message {\n    padding: 16px 0;\n  }\n\n  .message-content {\n    padding: 0 20px;\n  }\n\n  .input-container {\n    padding: 16px 20px 24px;\n  }\n\n  .welcome-message {\n    padding: 32px 20px;\n  }\n\n  .welcome-message h1 {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 640px) {\n  .app {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n    height: auto;\n    flex-direction: row;\n    border-right: none;\n    border-bottom: 1px solid var(--border-color);\n  }\n\n  .sidebar-header {\n    flex: 1;\n    border-bottom: none;\n    border-right: 1px solid var(--border-color);\n  }\n\n  .sidebar-content {\n    flex: 2;\n    padding: 16px;\n    flex-direction: row;\n    gap: 16px;\n    align-items: center;\n  }\n\n  .tools-section {\n    border-bottom: none;\n    border-right: 1px solid var(--border-color);\n    padding-right: 16px;\n    padding-bottom: 0;\n  }\n\n  .top-bar {\n    padding: 12px 16px;\n  }\n\n  .top-bar-left {\n    gap: 12px;\n  }\n}\n\n/* Plus button for attachments */\n.upload-btn {\n  cursor: pointer;\n  font-size: 20px;\n  user-select: none;\n  color: var(--text-secondary);\n  transition: color 0.2s ease;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  line-height: 1;\n}\n\n.upload-btn:hover {\n  color: var(--accent-color);\n}\n\n/* Memory-related styles */\n.memory-section {\n  border-top: 1px solid var(--border-color);\n  padding-top: 16px;\n  margin-top: 16px;\n}\n\n.memory-section h3 {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.memory-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  padding: 4px 8px;\n  transition: all 0.2s ease;\n}\n\n.memory-btn:hover {\n  background-color: var(--hover-color);\n  border-color: var(--text-secondary);\n}\n\n.memory-panel {\n  background-color: var(--bg-secondary);\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n  padding: 12px 20px;\n  font-size: 13px;\n}\n\n.memory-item {\n  margin-bottom: 8px;\n  padding: 6px;\n  background-color: var(--hover-color);\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n}\n\n.memory-item-meta {\n  font-size: 11px;\n  color: var(--text-secondary);\n  margin-top: 4px;\n}\n\n/* Tab Navigation Styles */\n.tab-navigation {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-left: 20px;\n}\n\n.tab-button {\n  padding: 8px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.tab-button:hover {\n  background: var(--hover-color);\n  border-color: var(--accent-color);\n}\n\n.tab-button.active {\n  background: var(--accent-color);\n  color: white;\n  border-color: var(--accent-color);\n}\n\n/* Custom Prompt Editor Styles */\n.prompt-toggle-btn:hover {\n  background-color: var(--hover-color) !important;\n  border-color: var(--accent-color) !important;\n}\n\n.prompt-editor-textarea {\n  width: 100%;\n  min-height: 80px;\n  max-height: 120px;\n  padding: 6px;\n  font-size: 10px;\n  background-color: var(--input-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  color: var(--text-primary);\n  resize: vertical;\n  font-family: 'SF Mono', Monaco, 'Roboto Mono', monospace;\n  line-height: 1.3;\n  transition: border-color 0.2s ease;\n}\n\n.prompt-editor-textarea:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 2px rgba(16, 163, 127, 0.1);\n}\n\n.prompt-editor-buttons {\n  display: flex;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.prompt-editor-btn {\n  flex: 1;\n  padding: 4px 6px;\n  border: none;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.prompt-editor-btn.update {\n  background-color: #10b981;\n  color: white;\n}\n\n.prompt-editor-btn.update:hover {\n  background-color: #059669;\n}\n\n.prompt-editor-btn.reset {\n  background-color: #ef4444;\n  color: white;\n}\n\n.prompt-editor-btn.reset:hover {\n  background-color: #dc2626;\n}\n\n.prompt-current-preview {\n  font-size: 9px;\n  color: var(--text-secondary);\n  margin-top: 4px;\n  padding: 3px 4px;\n  background-color: var(--bg-secondary);\n  border-radius: 2px;\n  border: 1px solid var(--border-color);\n  max-height: 40px;\n  overflow: hidden;\n}\n\n/* Modern Citation Card Styles */\n.citation-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin: 8px 0;\n  transition: all var(--transition-normal);\n  cursor: pointer;\n}\n\n.citation-card:hover {\n  background: var(--hover-color);\n  border-color: var(--accent-color);\n  box-shadow: var(--shadow-medium);\n  transform: translateY(-1px);\n}\n\n.citation-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.citation-badge {\n  background: var(--accent-light);\n  color: var(--accent-color);\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.citation-title {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.citation-snippet {\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 1.5;\n  margin-top: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.citation-meta {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.citation-similarity {\n  background: var(--bg-tertiary);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n/* Sources Panel Modern Style */\n.sources-panel {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  padding: 16px;\n  margin: 12px 0;\n}\n\n.sources-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.sources-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sources-toggle {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  transition: all var(--transition-fast);\n}\n\n.sources-toggle:hover {\n  background: var(--hover-color);\n  color: var(--accent-color);\n}\n\n/* Smooth fade-in animation for messages */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message {\n  animation: fadeInUp 0.3s ease-out;\n}\n\n/* Agent tools indicator */\n.agent-tools-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--accent-light);\n  color: var(--accent-color);\n  padding: 4px 10px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.agent-tools-badge::before {\n  content: '🔧';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
